module.exports = __webpack_public_path__ + "static/search-docs-1a83ffa5ff7bce86131833e6489665d3.svg";